
import themeMixin from '@/mixins/themeMixin'

import JCenterCol from '@/ui/controls/JCenterCol.vue'

export default themeMixin.extend({
  components: {
    JCenterCol,
  },
  // mixins: [themeMixin],
})
